import RouterSection from '@/Layout/components/RouterSection';

export default {
	path: '/',
	name: 'selected_home',
	component: RouterSection,
	mode: 'history',
	children: [
		{
			path: 'pick/:hashId?',
			name: 'pick',
			component: () => import('@/views/selectedCoupon/pick/index'),
		},
		{
			path: 'pickDetail',
			name: 'pickDetail',
			component: () => import('@/views/selectedCoupon/pick/detail'),
		},
		{
			path: 'pickFinish',
			name: 'pickFinish',
			component: () => import('@/views/selectedCoupon/pick/pickFinish'),
		},
	],
};
